module.exports = __webpack_public_path__ + "static/media/ladies_apparel_6.6893e42a.jpg";